import React, { useState, useEffect } from "react";
import { AppBar, Chip, Toolbar, IconButton, Stack, Drawer, List, ListItem, ListItemText, Box, CssBaseline } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import Notifications from "../shared/Notifications/Notification";
import Profile from '../shared/Profile/Profile'
import { Link, Outlet, useLocation } from "react-router-dom";
import { useSelector } from 'react-redux';
import logo from '../assets/images/logo.png';
import httpClient from "../_util/api";

const drawerWidth = 240;

const Layout = ({ navItems }) => {
  const location = useLocation();
  
  const userdetail = useSelector((state) => state.mainSlice.userdetail);

  const { role } = userdetail;

  const pathSegments = location.pathname.split("/");

  const [vendorBalance, setVendorBalance]= useState({});

  const segment = pathSegments[2] ?? "";

  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const getVendorBalance = async()=>{
      const res = await httpClient.get('/vendor-payment/balance').catch((error)=>{
          console.log(error.message);
      })
      if(res?.status === 200){
          setVendorBalance(res?.data)
      }
  }

  useEffect(()=>{
    if(role == "vendor") {
      getVendorBalance();
    }
  },[role])

  const drawer = (
    <List>
      {navItems.map((item) => (
        <ListItem
          button
          key={item.text}
          component={Link}
          to={item.path}
          sx={{
            backgroundColor: segment === item.path ? "#dff0d8" : "transparent",
            color: segment=== item.path ? "#4caf50" : "#333",
            "&:hover": {
              backgroundColor: "#dff0d8",
              color: "#4caf50",
            },
          }}
        >
          <ListItemText primary={item.text} />
        </ListItem>
      ))}
    </List>
  );
  return (
    <Box sx={{ display: "flex", backgroundColor: "#ffffff", minHeight: "100vh" }}>
      <CssBaseline />
      <AppBar position="fixed" sx={{ zIndex: 1201, backgroundColor: "#4caf50", color: "white", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)" }}>
        <Toolbar>
          <IconButton color="inherit" edge="start" onClick={handleDrawerToggle} sx={{ display: { sm: "none" }, mr: 2 }}>
            <MenuIcon />
          </IconButton>
          <Stack>
            <img src={logo} alt="Logo" style={{ height: "50px" }} />
          </Stack>
          <Box sx={{ ml: "auto", display: "flex", alignItems: "center" }}>
            {role == "vendor" && (
              <Chip
                label={`Balance: PKR ${vendorBalance.balance}`}
                color="info"
                variant="outlined"
                sx={{
                  fontSize: 14,
                  fontWeight: 500,
                  borderColor: '#fff',
                  color: '#fff',
                }}
              />
            )}
            {role !== "admin" && role !== "reviewer" && (
              <Notifications />
            )}
            <Profile />
          </Box>
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          [`& .MuiDrawer-paper`]: {
            marginTop: "64px",
            width: drawerWidth,
            boxSizing: "border-box",
            color: "#333",
            borderRight: "unset",
          },
          display: { xs: "none", sm: "block" },
        }}
        open
      >
        {drawer}
      </Drawer>
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        sx={{
          display: { xs: "block", sm: "none" },
          [`& .MuiDrawer-paper`]: {
            width: drawerWidth,
            backgroundColor: "#f0f8f4",
            color: "#333",
            boxShadow: "2px 0px 10px rgba(0, 0, 0, 0.1)",
          },
        }}
      >
        {drawer}
      </Drawer>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: { xs: "100%", sm: `calc(100% - ${drawerWidth}px)` },
          mt: "64px",
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default Layout;
